
import { Component, Mixins } from "vue-property-decorator";
import { CheckBehavior, PatientProfileCheckKinds } from "../../../../../../documaker/domain/format/objects";
import { ICheckBehaviorPropertyEditable, instanceOfICheckBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class CheckBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICheckBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICheckBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isCheckBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICheckBehaviorPropertyEditable(s) && s.checkBehavior().isEditable(), false);
  }

  get isGroupScopeSelectable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICheckBehaviorPropertyEditable(s) && s.isGroupScopeSelectable(), false);
  }

  get checkBehavior(): CheckBehavior {
    return this.readPropertyOrDefault(s => CheckBehavior.from(s.checkBehavior().getValue()), new CheckBehavior(true, true));
  }

  set checkBehavior(value: CheckBehavior) {
    this.writePropertyWhenValid(s => s.checkBehavior().setValue(CheckBehavior.to(value)));
  }

  get isPatientProfileCheckKindSelectable(): boolean {
    return this.readPropertyOrDefault(s => s.isPatientProfileCheckKindSelectable(), false);
  }

  get getSelectablePatientProfileCheckKinds(): PatientProfileCheckKinds[] {
    return this.readPropertyOrDefault(s => s.getSelectablePatientProfileCheckKinds(), null);
  }
}
